import WCCSliderAdaptiveItem from "../item/adaptive/adaptive.model";
import WCCSliderItem from "../item/base/base.model";
import WCCSliderDynamicItem from "../item/dynamic/dynamic.model";
import WCCSliderFullscreenItem from "../item/fullscreen/fullscreen.model";
import { WCCSliderAdaptiveLayoutConfig } from "../layouts/adaptive";
import { WCCSliderBaseLayoutConfig } from "../layouts/base";
import { WCCSliderDynamicLayoutConfig } from "../layouts/dynamic";
import { WCCSliderFullscreenLayoutConfig } from "../layouts/fullscreen";
import { IWCCSliderLayout } from "../layouts/layout.interfaces";

export const wccSliderLayoutsFactoryKey = Symbol();

export type ExtendedWCCSliderLayoutConfig<T, I extends WCCSliderItem<T> = WCCSliderItem<T>> = WCCSliderLayoutConfig & WCCSliderBaseLayoutConfig<T, I>
export type ExtendedWCCSliderAdaptiveLayoutConfig<T> = WCCSliderAdaptiveLayoutConfigPublic & WCCSliderBaseLayoutConfig<T, WCCSliderAdaptiveItem<T>>
export type ExtendedWCCSliderDynamicLayoutConfig<T> = WCCSliderDynamicLayoutConfigPublic & WCCSliderBaseLayoutConfig<T, WCCSliderDynamicItem<T>>
export type ExtendedWCCSliderFullscreenLayoutConfig<T> = WCCSliderFullscreenLayoutConfigPublic & WCCSliderBaseLayoutConfig<T, WCCSliderFullscreenItem<T>>

export type WCCSliderLayoutConfig = WCCSliderAdaptiveLayoutConfigPublic | WCCSliderDynamicLayoutConfigPublic | WCCSliderFullscreenLayoutConfigPublic

export interface WCCSliderAdaptiveLayoutConfigPublic extends WCCSliderAdaptiveLayoutConfig {
    type: 'adaptive'
}

export interface WCCSliderDynamicLayoutConfigPublic extends WCCSliderDynamicLayoutConfig {
    type: 'dynamic'
}

export interface WCCSliderFullscreenLayoutConfigPublic extends WCCSliderFullscreenLayoutConfig {
    type: 'fullscreen'
}

export interface IWCCSliderLayoutsFactory<T = any> {
    build(config: ExtendedWCCSliderLayoutConfig<T>): IWCCSliderLayout<T>
}